import { css } from "@emotion/react";
import colors from "assets/css/colors";

export default {
  className: css`
    max-width: 459px;
    margin: 64px auto 40px;
  `,
  overlayClassName: css`
    position: fixed;
    inset: 0;
    background-color: ${colors.blackOverlay};
    z-index: 1000;
    padding: 0 15px;
  `,
};
